const Actions = ({ children }) => {
    return (
        <div class="main-list__controls">
            <div class="search-input-header"> 
            </div>
            <div className="main-list__header-buttons" style={{ display: "flex", alignItems: "center" }}>
                    {children}
            </div>
        </div>
    );
};

export default Actions;
